<template>
  <div class="Pos_main">
    <!-- Sales-Channel -->

    <div class="pos_Tmall">
      <SumTable ref="table"></SumTable>
    </div>
  </div>
</template>

<script>
import SumTable from "@/components/ButSecoend/Ecview/SumTable";

export default {
  data() {
    return {
      // updataTime1: "2020-05-19",
      updataTimeIn: "2020-05-19",
      updataTimeOut: "2020-05-19",

      typeValue: {},
      achVing: sessionStorage.getItem("achVing"),
      title: "",
    };
  },
  methods: {
    getTime() {
      this.$addr
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getUpdateDate")
        // .get("sellin/getUpdateDate")
        .get("sellinAndsellout/getUpdateDateSellinAndSellout")
        .then((res) => {
          this.updataTimeIn = res.data.data.GTS_UPDATE_DATE;
          this.updataTimeOut = res.data.data.VERSION_UPDATE_DATE_SELLOUT;

          this.title = res.data.data.YYYYMM_EN;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },

    getTypeData() {
      this.$addr
        // .post("/getSalesData", qs.stringify({ brandCd: this.brandName }))
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getBuByList")
        // .get("sellin/getTargetType")
        .get("sellinAndsellout/getSumDataSellinAndSellout")
        .then((res) => {
          if (res.data.error == 0) {
            this.typeValue = res.data.data[0];
          }
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
  },
  components: {
    SumTable,
  },
  created() {
    this.getTime();

    this.getTypeData();
  },
};
</script>

<style  scoped>
.Pos_main {
  min-height: 740px;
  width: 100%;
  background: #f6f6ff;
  box-shadow: inset 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  overflow: hidden;
}
.Pos_main .all_nav,
.Pos_main .Tmall_nav,
.Pos_main .stage_nav {
  background: #f6f6ff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  background: #d1534b;
  border-radius: 22.5008px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Pos_main .all_nav {
  margin: 20px 20px 0px 16px;
}
.Pos_main .Tmall_nav {
  margin: 0px 20px 10px 16px;
}
.Pos_main .stage_nav {
  margin: 0px 20px 10px 16px;
}

.Pos_main .all_nav p,
.Tmall_nav p,
.stage_nav p {
  margin-left: 15px;
  font-family: "微软雅黑" !important;
  font-size: 16px;
  color: #ffffff;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Pos_main .all_nav span,
.Tmall_nav span,
.stage_nav span {
  opacity: 0.6;
  font-family: "微软雅黑" !important;
  font-size: 12px;
  color: #f3f3f3;
  text-align: center;
  margin-right: 15px;
}
.Pos_main .pos_all {
  position: relative;
  min-height: 200px;
  width: 100%;
  margin: 0 auto;
}

.pos_all {
  overflow: hidden;
}
.pos_Tmall {
  overflow: hidden;
}
.Full_stage {
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/ButSecoend/Ecview/Summary.vue